module.exports = __webpack_public_path__ + "static/favicon-a9e9c92f4ac1135f80f95a35e74b736f.png";